const SET_LOG = 'editLog/SET_LOG';

export default {
  SET_LOG,
};
